/*
  Typography specifications
 */
import { colors } from './colors';

export const typography = {
  h1: {
    fontSize: '1.5rem',
    fontWeight: 600,
    paddingTop: '8px',
    paddingBottom: '4px',
    letterSpacing: 'normal',
    color: colors.common.black,
    fontFamily: 'Inter'
  },
  h2: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.5,
    paddingTop: '6px',
    paddingBottom: '4px',
    letterSpacing: 'normal',
    color: colors.common.black,
    fontFamily: 'Inter'
  },
  h4: {
    fontSize: '1.125rem',
    fontWeight: 'bold',
    lineHeight: 1.5,
    paddingTop: '5px',
    paddingBottom: '4px',
    letterSpacing: 'normal',
    color: colors.common.black,
    fontFamily: 'Inter'
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 'bold',
    lineHeight: 1.5,
    paddingTop: '5px',
    paddingBottom: '4px',
    letterSpacing: 'normal',
    color: colors.common.white,
    fontFamily: 'Inter'
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: "#808080",
    fontFamily: 'Inter'
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: "#808080",
    fontFamily: 'Inter'
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: colors.common.black,
    fontFamily: 'Inter'
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 'normal',
    lineHeight: 1.29,
    letterSpacing: 'normal',
    color: colors.common.black,
    fontFamily: 'Inter'
  }
};
